import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import { AddRoleResponse } from "../../../models/response/role/AddRoleResponse";
import { GetRoleByIdResponse } from "../../../models/response/role/GetRoleByIdResponse";
import CustomTextInput from "../../../components/CustomTextInput";
import { useMask } from "@react-input/mask";
import { CompanyService } from "../../../services/CompanyService";
import CustomMultiSelect, { CustomMultiSelectModel } from "../../../components/CustomMultiSelect";
import { RoleService } from "../../../services/RoleService";
import { GetMenuListResponse, GetMenuListResponseItem } from "../../../models/response/menu/GetMenuListResponse";
import { MenuService } from "../../../services/MenuService";
import { GetRoleMenusByRoleIdResponse, GetRoleMenusByRoleIdResponseItem } from "../../../models/response/roleMenu/GetRoleMenusByRoleIdResponse";
import { RoleMenuService } from "../../../services/RoleMenuService";
import { AddRoleMenuRangeResponse } from "../../../models/response/roleMenu/AddRoleMenuRangeResponse";
import { RootState } from "../../../redux/store";

const RoleAdd = () => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Ayarlar > Rol Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [roleId, setRoleId] = useState<string | undefined>(undefined);
    const [roleName, setRoleName] = useState<string | undefined>(undefined);
    const [menuList, setMenuList] = useState<GetMenuListResponseItem[]>([])
    const [roleMenuList, setRoleMenuList] = useState<GetRoleMenusByRoleIdResponseItem[]>([])
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            if (auth.user.user?.data.isAdmin) {
                var response2: GetMenuListResponse = await MenuService.getMenuList();

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                setMenuList(response2.data);
            }
            else {
                setMenuList((auth.user.user?.data.authorizedMenus ?? []).map(function (x) {
                    return { name: x.menuName, menuId: x.menuId }
                }));
            }

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response3: GetRoleMenusByRoleIdResponse = await RoleMenuService.getRoleMenusByRoleId(id);

                if (!response3.isSuccess) {
                    toast.error(response3.message)
                    return;
                }

                setRoleMenuList(response3.data);

                var response: GetRoleByIdResponse = await RoleService.getRoleById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setRoleId(response.data.roleId);
                setRoleName(response.data.name);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const saveRole = async () => {
        try {
            if (Helpers.isEmpty(roleName))
                toast.error('Rol Adı alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var response: AddRoleResponse = await RoleService.addRole(roleId, roleName);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                var response2: AddRoleMenuRangeResponse = await RoleMenuService.addRoleMenuRange({
                    roleId: response.data.roleId,
                    items: roleMenuList.map(function (x) {
                        x.roleId = response.data.roleId;

                        return x;
                    })
                });

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    dispatch(storeActivityIndicator(false))
                    return;
                }

                toast.success("Başarıyla kaydedilmiştir.");

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const onChangeMain = (_menuId: string) => {
        var control = roleMenuList.find(x => x.menuId == _menuId);

        if (control)
            setRoleMenuList(roleMenuList.filter(x => x.menuId != _menuId))
        else
            setRoleMenuList([...roleMenuList, {
                canDelete: true,
                canInsert: true,
                canUpdate: true,
                canExcel: true,
                canDocument: true,
                createdDate: '',
                createdUser: '',
                menuId: _menuId,
                roleId: '',
                roleMenuId: '',
                updatedDate: '',
                updatedUser: ''
            }])
    }

    const onChangeCanInsert = (_menuId: string) => {
        setRoleMenuList(roleMenuList.map(function (x) {
            if (x.menuId == _menuId)
                x.canInsert = !x.canInsert;

            return x;
        }))
    }

    const onChangeCanExcel = (_menuId: string) => {
        setRoleMenuList(roleMenuList.map(function (x) {
            if (x.menuId == _menuId)
                x.canExcel = !x.canExcel;

            return x;
        }))
    }

    const onChangeCanDelete = (_menuId: string) => {
        setRoleMenuList(roleMenuList.map(function (x) {
            if (x.menuId == _menuId)
                x.canDelete = !x.canDelete;

            return x;
        }))
    }

    const onChangeCanUpdate = (_menuId: string) => {
        setRoleMenuList(roleMenuList.map(function (x) {
            if (x.menuId == _menuId)
                x.canUpdate = !x.canUpdate;

            return x;
        }))
    }

    const onChangeCanDocument = (_menuId: string) => {
        setRoleMenuList(roleMenuList.map(function (x) {
            if (x.menuId == _menuId)
                x.canDocument = !x.canDocument;

            return x;
        }))
    }

    const selectAll = () => {
        if (!isSelectAllChecked) {
            setRoleMenuList(menuList.map(function (x) {
                return {
                    canDelete: true,
                    canInsert: true,
                    canUpdate: true,
                    canExcel: true,
                    canDocument: true,
                    createdDate: '',
                    createdUser: '',
                    menuId: x.menuId,
                    roleId: '',
                    roleMenuId: '',
                    updatedDate: '',
                    updatedUser: ''
                }
            }));
        }
        else {
            setRoleMenuList([]);
        }


        setIsSelectAllChecked(!isSelectAllChecked);
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className='row'>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Rol Adı</label>
                                            <CustomTextInput value={roleName} setValue={setRoleName} />
                                        </div>
                                    </div>
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <div>
                        <KTCard className="ebbe-card mt-10">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Yetki Bilgileri</h4>

                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='table-responsive'>
                                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                                <thead>
                                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                                        <th style={{ width: 1 }}>
                                                            <div className='d-flex'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                    <input onChange={() => selectAll()} checked={isSelectAllChecked} className='form-check-input' type='checkbox' />
                                                                </label>
                                                            </div>
                                                        </th>
                                                        <th>Menü Adı</th>
                                                        <th>Ekleme</th>
                                                        <th>Silme</th>
                                                        <th>Güncelleme</th>
                                                        <th>Excel</th>
                                                        <th>Evrak</th>
                                                    </tr>
                                                </thead>
                                                <tbody className='text-gray-600 fw-bold'>
                                                    {
                                                        menuList.map((item, index) =>
                                                            <tr style={{ opacity: roleMenuList.find(x => x.menuId == item.menuId) ? 1 : 0.5 }}>
                                                                <td>
                                                                    <div className='d-flex'>
                                                                        <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                            <input onChange={() => onChangeMain(item.menuId)} className='form-check-input' type='checkbox' checked={roleMenuList.find(x => x.menuId == item.menuId) !== undefined} />
                                                                        </label>
                                                                    </div>
                                                                </td>
                                                                <td>{item.name}</td>
                                                                <td>
                                                                    <div className='d-flex'>
                                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                            <input onChange={() => onChangeCanInsert(item.menuId)} disabled={roleMenuList.find(x => x.menuId == item.menuId) === undefined} className='form-check-input' type='checkbox' checked={roleMenuList.find(x => x.menuId == item.menuId)?.canInsert === true} />
                                                                        </label>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className='d-flex'>
                                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                            <input onChange={() => onChangeCanDelete(item.menuId)} disabled={roleMenuList.find(x => x.menuId == item.menuId) === undefined} className='form-check-input' type='checkbox' checked={roleMenuList.find(x => x.menuId == item.menuId)?.canDelete === true} />
                                                                        </label>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className='d-flex'>
                                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                            <input onChange={() => onChangeCanUpdate(item.menuId)} disabled={roleMenuList.find(x => x.menuId == item.menuId) === undefined} className='form-check-input' type='checkbox' checked={roleMenuList.find(x => x.menuId == item.menuId)?.canUpdate === true} />
                                                                        </label>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className='d-flex'>
                                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                            <input onChange={() => onChangeCanExcel(item.menuId)} disabled={roleMenuList.find(x => x.menuId == item.menuId) === undefined} className='form-check-input' type='checkbox' checked={roleMenuList.find(x => x.menuId == item.menuId)?.canExcel === true} />
                                                                        </label>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className='d-flex'>
                                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                            <input onChange={() => onChangeCanDocument(item.menuId)} disabled={roleMenuList.find(x => x.menuId == item.menuId) === undefined} className='form-check-input' type='checkbox' checked={roleMenuList.find(x => x.menuId == item.menuId)?.canDocument === true} />
                                                                        </label>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveRole}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default RoleAdd;